var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavCategoryPerformance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.033 10.348a3.395 3.395 0 0 1 2.756 5.375l.39.39.058.065a.849.849 0 0 1-1.193 1.193l-.065-.057-.5-.5a3.395 3.395 0 1 1-1.446-6.466m0 1.697a1.698 1.698 0 1 0 .002 3.396 1.698 1.698 0 0 0-.002-3.396",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.42 2.438c.47 0 .85.38.85.85v1.889h6.913a2.97 2.97 0 1 1 0 1.698H4.27v3.482c0 .608 0 1.014.025 1.325.025.3.069.439.113.526.122.24.317.436.557.558.087.044.226.087.526.112.311.025.716.025 1.324.025h1.859a.849.849 0 0 1 0 1.698H6.815c-.58 0-1.066 0-1.462-.032-.406-.033-.792-.105-1.159-.292a2.97 2.97 0 0 1-1.298-1.298c-.186-.367-.26-.752-.292-1.159-.033-.396-.032-.883-.032-1.463v-7.07c0-.469.38-.849.849-.849"
})));
SvgNavCategoryPerformance.displayName = "SvgNavCategoryPerformance";
export { SvgNavCategoryPerformance as ReactComponent };
export default SvgNavCategoryPerformance;